// extracted by mini-css-extract-plugin
export default {"o-icon":"Icon_o-icon__YFqz-"};